import { prop, inject } from "fw";
import { AccountType, AtsOrganization } from "models/ats-organization";

@inject
export class PanelOrganizations {
    @prop(null) organization: AtsOrganization;

    public getAccountType = (value: AccountType | null): string => {
        return AccountType[value];
    };
}
